module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"link":"View on Amazon","articleTitle":"Title","viewArticle":"View in article","priceInArticle":"Price in article","priceCurrent":"Current price"}}')
  delete Component.options._Ctor
}
